import { createRoute } from "@tanstack/react-router";
import { requirePermissions } from "@/app/guards";
import { BATCHES_PERMISSIONS } from "@/app/nav";
import { BatchDetail, NoBatchSelected } from "@/features/batches/BatchDetail";
import { BatchMonitor, MONITOR_STATUSES, type MonitorStatus } from "@/features/batches/BatchMonitor";
import { type PageSearch, pageSearch } from "@/routes/paging";
import { staffRoute } from "@/routes/staff";

type BatchesSearch = { status?: MonitorStatus } & PageSearch;

const isMonitorStatus = (value: unknown): value is MonitorStatus =>
  MONITOR_STATUSES.includes(value as MonitorStatus);

export const batchesRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "batches",
  // An unknown ?status= falls back to the default view. The key must be set to undefined, not
  // omitted: the router merges this result over the raw query, so omitting it keeps "bogus".
  validateSearch: (search: Record<string, unknown>): BatchesSearch => ({
    status: isMonitorStatus(search.status) ? search.status : undefined,
    ...pageSearch(search),
  }),
  beforeLoad: ({ context }) => requirePermissions(context.session, BATCHES_PERMISSIONS),
  component: BatchMonitor,
});

export const batchesIndexRoute = createRoute({
  getParentRoute: () => batchesRoute,
  path: "/",
  component: NoBatchSelected,
});

export const batchDetailRoute = createRoute({
  getParentRoute: () => batchesRoute,
  path: "$batchId",
  component: BatchDetail,
});
